import { useState } from 'react'
import './FolderNameInputPopUp.css'

function FolderNameInputPopUp(props) {

    const { isInputOpen, setIsInputOpen, createFolder } = props

    const [foldername, setFoldername] = useState('')

    function setInputText(text) {
        setFoldername(text)
    }

    if (isInputOpen === false) {
        return ''
    }
    else {
        return <div className='folder-popup-container'>
            <div className='folder-popup'>
                <input  id='foldername-input' type="text" onChange={(event) => { setInputText(event.target.value); }} placeholder='Enter folder name' autoFocus/>
                <div className="folder-popup-buttons">
                    <button id='ok' onClick={() => { createFolder(foldername); setFoldername(''); setIsInputOpen(false) }}>Ok</button>
                    <button id='cancel' onClick={() => { setIsInputOpen(false) }}>Cancel</button>
                </div>
            </div>
        </div>
    }
}

export default FolderNameInputPopUp;